/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createBignumber } from '../../factoriesAny.js';
export var bignumberDependencies = {
  BigNumberDependencies,
  typedDependencies,
  createBignumber
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesBignumber.generated.js
// module id = jzm0
// module chunks = 3